import platformConfig from '@/config/PlatformConfig'
const isProduction = process.env.NODE_ENV !== 'development'

const config = {
  options: {
    isEnabled: true,
    logLevel: isProduction ? 'error' : 'debug',
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true,
  },
  baseURL: '',
  routerBase: '',
}

switch (process.env.NODE_ENV) {
  case 'release':
  case 'release-qa':
  case 'production':
    config.baseURL = `${window.location.protocol}//${window.location.host}/gateway`
    break
  case 'development':
    config.baseURL = platformConfig.baseURL
    break
  default:
    // local
    config.baseURL = platformConfig.baseURL
}

export { config }
